import '../game.css';
const React = require('react');
const { DragSource, DragPreviewImage } = require('react-dnd');
const dragType = require('../../../define/dragType').default;
const object = require('../../../define/object').default;
const assets = require('../../../assets').default;

const { getShapeArrayPosition } = require('../../../core/shape').default;


// ============================
const dragSpec = {
    beginDrag(props) {
        const { type, porins, rotate, frameId } = props;
        return { type, porins, rotate, frameId };
    }
}

function collect(connect, monitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        // You can ask the monitor about the current drag state:
        isDragging: monitor.isDragging()
    }
}

const Panel = (type) => {
    let imageSrc = undefined;
    switch (type) {
        case object.OBJ_BOM_RED:
            imageSrc = assets.PorinBoxRed;
            break;
        case object.OBJ_BOM_GREEN:
            imageSrc = assets.PorinBoxGreen;
            break;
        case object.OBJ_BOM_BLUE:
            imageSrc = assets.PorinBoxBlue;
            break;
        case object.OBJ_BOM_YELLOW:
            imageSrc = assets.PorinBoxYellow;
            break;
        default:
            break;
    }
    return (
        <div className="selector-porin-box-panel-base">
            {imageSrc ? <img src={imageSrc} className="selector-porin-box-panel-img" /> : <div className="selector-porin-box-panel-img" />}
        </div>
    );
}

class porinBoxComponent extends React.Component {
    renderPanel(index) {
        const { type, porins, rotate } = this.props;
        const shapeArray = getShapeArrayPosition(type, rotate);
        const x = index % 4;
        const y = Math.floor(index / 4);
        const objectIndex = shapeArray.findIndex(position => (x === position.posX && y === position.posY));
        return (
            <div key={index} className="selector-porin-box-panel">
                {Panel(objectIndex !== undefined ? porins[objectIndex] : object.OBJ_BLANK)}
            </div>
        )
    }

    renderPorinBox() {
        const panels = []
        for (let i = 0; i < (4 * 4); i++) {
            panels.push(this.renderPanel(i));
        }
        return (
            <div className="selector-porin-box">
                {panels}
            </div>
        )
    }

    render() {
        const opacity = this.props.isDragging ? 0.4 : 1;
        return (
            <>
                <DragPreviewImage connect={this.props.connectDragPreview} src={assets.IconPorinBox} />
                <div ref={this.props.connectDragSource} style={{ opacity }}> {this.renderPorinBox()}</div >
            </>
        )
    }
}

export default DragSource(dragType.PORIN_BOX, dragSpec, collect)(porinBoxComponent);